import React, { useContext } from 'react';
import { ModifyPlaylistButton } from '@atlassian/ai-audio/ui/buttons';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { PageCardContext } from '../PageCardContext.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';

const WrappedButton = ({ flags }) => {
	const { cloudId } = useSessionData();
	const { id, type, title } = useContext(PageCardContext);

	return (
		cloudId &&
		type === 'page' &&
		fg('confluence_audio_briefings_v3') && (
			<ModifyPlaylistButton
				cloudId={cloudId}
				contentId={id}
				contentType={type}
				title={title.text}
				subtle
				flagsOverride={flags}
			/>
		)
	);
};

export const AudioPlaylistButton = withFlags(WrappedButton);
